<template>
  <section>
    <PageTitle>
      <span v-html="title" />
    </PageTitle>
    <PageContent>
      <Container>
        <div class="page-static" v-html="text" ref="content" />
      </Container>
    </PageContent>
  </section>
</template>

<script>
import staticApi from '@/api/static'
import { sanitizeHTML, clearHTML } from '@/utils/dom'
import { renderError } from '@/utils/error'
import initInjectedHTML from '@/utils/init-injected-html'

export default {
  metaInfo() {
    return {
      title: this.page.page_title,
      bodyAttrs: { class: `static-${this.pageId}` }
    }
  },
  data() {
    return {
      page: {
        page_title: '',
        page_text: ''
      }
    }
  },
  methods: {
    async fetchPage() {
      try {
        this.page = await staticApi.get(this.pageId)
      } catch(err) {
        renderError(err)
      }
    }
  },
  computed: {
    pageId() {
      return this.$route.params.id
    },
    title() {
      return clearHTML(this.page.page_title)
    },
    text() {
      return sanitizeHTML(this.page.page_text)
    }
  },
  created() {
    this.$withLoading(this.fetchPage)
  },
  watch: {
    $route: 'fetchPage',
    page: function() {
      this.$nextTick(() => {
        initInjectedHTML(this.$refs.content)
      })
    }
  }
}
</script>
